import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSectionLRIcons from '@elem/ui/ef-section-l-r-icons';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useState } from 'react';
import IconA1 from './IconA1';
import IconA2 from './IconA2';
import IconA3 from './IconA3';
import IconA4 from './IconA4';
import IconA5 from './IconA5';
import IconA6 from './IconA6';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabB');
    const tabObj: any = {
        a: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723726806097/c1.png',
            title: t('a_title'),
            desc: t('a_desc'),
            list: [
                {
                    title: t('a_item1'),
                    icon: <IconA1 />,
                },
                {
                    title: t('a_item2'),
                    icon: <IconA2 />,
                },
                {
                    title: t('a_item3'),
                    icon: <IconA3 />,
                },
                {
                    title: t('a_item4'),
                    icon: <IconA4 />,
                },
                {
                    title: t('a_item5'),
                    icon: <IconA5 />,
                },
                {
                    title: t('a_item6'),
                    icon: <IconA6 />,
                },
            ],
        },
        b: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723726880267/c2.png',
            title: t('b_title'),
            desc: t('b_desc'),
            list: [
                {
                    title: t('b_item1'),
                    icon: <IconA1 />,
                },
                {
                    title: t('b_item2'),
                    icon: <IconA2 />,
                },
                {
                    title: t('b_item3'),
                    icon: <IconA3 />,
                },
                {
                    title: t('b_item4'),
                    icon: <IconA4 />,
                },
                {
                    title: t('b_item5'),
                    icon: <IconA5 />,
                },
                {
                    title: t('b_item6'),
                    icon: <IconA6 />,
                },
            ],
        },
        c: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723726806283/c3.png',
            title: t('c_title'),
            desc: t('c_desc'),
            list: [
                {
                    title: t('c_item1'),
                    icon: <IconA1 />,
                },
                {
                    title: t('c_item2'),
                    icon: <IconA2 />,
                },
                {
                    title: t('c_item3'),
                    icon: <IconA3 />,
                },
                {
                    title: t('c_item4'),
                    icon: <IconA4 />,
                },
                {
                    title: t('c_item5'),
                    icon: <IconA5 />,
                },
                {
                    title: t('c_item6'),
                    icon: <IconA6 />,
                },
            ],
        },
    };
    const items1 = [
        {
            type: 'a',
            title: t('a_tab'),
        },
        {
            type: 'b',
            title: t('b_tab'),
        },
        {
            type: 'c',
            title: t('c_tab'),
        },
    ];

    // 选中的tab
    const [activeType, setActiveType] = useState('a');
    const [activeItem, setActiveItem] = useState(tabObj[activeType]);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
        setActiveItem(tabObj[item.type] || tabObj['a']);
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <div className="ef-container">
                <EfSection label={t('label')} title={t('title')} desc={t('desc')} />
                <EfSectionLRIcons pc={activeItem.pc} title={activeItem.title} desc={activeItem.desc} list={activeItem.list} />
                <EfTab items={items1} onChange={activeTypeCallback} />
            </div>
            <EfSpec />
        </div>
    );
}
